import React from "react";
import { Button, Drawer } from "@payping/web-components";
import { Close } from "@payping/icons";
import { useNavigate } from "react-router-dom";
import { useAppTranslation } from "@/utils";
import { DashboardRoutes } from "@/router/constant";
import SettingsBankList from "@/pages/Settings/Bank/BankList";

const MobileBankList: React.FC = () => {
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  const { settings } = DashboardRoutes;

  return (
    <Drawer
      open={true}
      placement={"bottom"}
      height={"100%"}
      title={t("profile.main.bank")}
      closeIcon={false}
      extra={
        <Button
          type={"text"}
          icon={<Close width={14} height={14} />}
          onClick={() => {
            navigate(settings.mRoot.url);
          }}
        />
      }
    >
      <SettingsBankList />
    </Drawer>
  );
};

export default MobileBankList;
